// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import zenscroll from 'zenscroll'
import { DateTime } from 'luxon'

// Internal Dependencies:
import Schedule from 'components/Schedule/Schedule'
import CurrentPlaylist from 'components/NowPlaying/CurrentPlaylist'
import LoadingSpinner from 'components/LoadingSpinner/LoadingSpinner'
import { getUtcTimestampSeconds } from 'utilities/time'

// Redux:
import { toggleAccountDropdown } from 'actions/site'
import { getFullScheduleData, goToTrack } from 'actions/schedule'

class SchedulePlayer extends React.Component {
	constructor( props ) {
		super( props )

		let state = {
			scheduleShow: 'next',
			isLoading: false,
			showCalendar: false,
			changedDay: false,
			currentDateTime: DateTime.local(),
			currentJsDate: DateTime.local().toJSDate(),
			minimumDate: DateTime.local().minus( { days: 30 } ).toJSDate(),
			maximumDate: DateTime.local().plus( { days: 2 } ).toJSDate(),
			selectedWeekDay: DateTime.local().toFormat( 'EEEE' ),
			selectedWeekDayNumber: DateTime.local().toFormat( 'c' ), // Monday is first.
			selectedMonth: DateTime.local().toFormat( 'MM' ),
			selectedMonthRendered: DateTime.local().toFormat( 'LLLL' ),
			selectedDay: DateTime.local().toFormat( 'dd' ),
			maxSelectedDateTime: DateTime.local().plus( { days: 2 } ),
			maxDayReached: false,
			week: [],
			showNotice: false,
			noticeText: ''
		}

		this.state = state
	}

	componentDidMount() {
		const { nowPlaying } = this.props

		this._ismounted = true
	}

	componentWillUnmount() {
		this._ismounted = false
	}

	componentDidUpdate( prevProps ) {

	}

	scheduleShowAfterNow = () => {
		this.setState( {
			scheduleShow: 'next'
		} )
	}

	scheduleShowBeforeNow = () => {
		this.setState( {
			scheduleShow: 'previous'
		} )
	}

	updateSelectedDay = ( newDateTime ) => {
		const { getFullScheduleData } = this.props
		const { maxSelectedDateTime } = this.state

		// If a later date than the max is selected, use the max:
		if ( maxSelectedDateTime < newDateTime ) {
			newDateTime = maxSelectedDateTime
		}

		const selectedDay = newDateTime.toFormat( 'dd' )
		const selectedMonth = newDateTime.toFormat( 'MM' )

		this.setState( {
			currentDateTime: newDateTime,
			currentJsDate: newDateTime.toJSDate(),
			selectedWeekDay: newDateTime.toFormat( 'EEEE' ),
			selectedWeekDayNumber: newDateTime.toFormat( 'c' ),
			selectedMonth: selectedMonth,
			selectedMonthRendered: newDateTime.toFormat( 'LLLL' ),
			selectedDay: selectedDay
		} )

		// Get schedule data:
		getFullScheduleData( selectedDay, selectedMonth )
	}

	setNotice = ( text ) => {
		this.setState( {
			showNotice: true,
			noticeText: text
		} )

		setTimeout( () => {
			this.setState( {
				showNotice: false
			} )
		}, 4000 )
	}

	showCalendar = () => {
		this.setState( {
			showCalendar: true
		} )
	}

	hideCalendar = () => {
		this.setState( {
			showCalendar: false
		} )
	}

	handleDatePicked = ( date ) => {
		// Update the selected day:
		const newDateTime = DateTime.fromJSDate( date )

		this.updateSelectedDay( newDateTime )
		this.hideCalendar()
	}

	renderHeaderNav() {
		const { maxDayReached, selectedWeekDay, selectedMonthRendered, selectedMonth, selectedDay } = this.state
		const nextClass = maxDayReached ? '-next is-disabled' : '-next'

		if ( ! selectedWeekDay ) {
			return null
		}

		return (
			<div onClick={ this.showCalendar }>
				<div className="schedule-calendar-button">
					<div className="-icon">
						<i className="icon-calendar"></i>
					</div>

					<div className="-text">{ `${selectedWeekDay}, ${selectedMonthRendered} ${selectedDay}` }</div>
				</div>
			</div>
		)
	}

	render() {
		const { fullSchedule, nowPlaying, siteId, stationsById, timezoneType, page } = this.props
		const { isLoading, showNotice, noticeText, showCalendar, currentDateTime, currentJsDate, minimumDate, maximumDate, selectedDay, selectedWeekDay, selectedMonth } = this.state
		let { scheduleShow } = this.state
		const fmText = 'AICE' == siteId || 'AVST' == siteId ? '' : ' FM'
		const stationScheduleText = 'AICE' == siteId || 'AVST' == siteId ? 'Schedule' : ' Schedule'

		if ( isLoading || ! fullSchedule ) {
			return <LoadingSpinner />
		}

		if ( nowPlaying.is_playlist ) {
			scheduleShow = 'playlist'
		}

		return (
			<div className="schedule-page-wrap">
				{ noticeText &&
					<div className={ siteNoticeClass }>
						<p>{ noticeText }</p>
					</div>
				}

				{ ( fullSchedule && ( 'next' == scheduleShow || 'previous' == scheduleShow ) ) && this.renderHeaderNav() }

				{ ! isLoading &&
					<div className="now-playing-schedule-wrap">
						{ ( 'next' == scheduleShow || 'previous' == scheduleShow ) &&
							<div className="now-playing-schedule-controls">
								<div className={ 'next' == scheduleShow ? '-button is-active' : '-button' } onClick={ this.scheduleShowAfterNow }>Up Next</div>

								<div className={ 'previous' == scheduleShow ? '-button is-active' : '-button' } onClick={ this.scheduleShowBeforeNow }>Recently Played</div>
							</div>
						}

						{ 'next' == scheduleShow &&
							<div className="schedule-programs-wrap">
								<Schedule
									isListenPage={ true }
									dateTime={ currentDateTime }
									selectedDay={ selectedDay }
									selectedWeekDay={ selectedWeekDay }
									selectedMonth={ selectedMonth }
									showAfterNow={ true }
								/>
							</div>
						}

						{ 'previous' == scheduleShow &&
							<div className="schedule-programs-wrap">
								<Schedule
									isListenPage={ true }
									dateTime={ currentDateTime }
									selectedDay={ selectedDay }
									selectedWeekDay={ selectedWeekDay }
									selectedMonth={ selectedMonth }
									showBeforeNow={ true }
								/>
							</div>
						}

						{ 'playlist' == scheduleShow &&
							<div className="program-podcasts">
								<div className="schedule-programs-wrap">
									<CurrentPlaylist />
								</div>
							</div>
						}

						<Link to="/schedule" className="schedule-full-button">
							<div className="-icon">
								<i className="icon-calendar" />
							</div>

							<div className="-text">View Full Schedule</div>
						</Link>
					</div>
				}
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		isMobile: state.site.isMobile,
		page: state.page.selected,
		fullSchedule: state.schedule.fullSchedule,
		programsById: state.programs.byId,
		nowPlaying: state.schedule.nowPlaying,
		mediaError: state.schedule.mediaError,
		timezone: state.schedule.timezone,
		timezoneOffset: state.schedule.timezoneOffset,
		timezoneType: state.schedule.timezoneType,
		siteId: state.schedule.siteId,
		stationsById: state.schedule.stationsById,
		selectedItem: state.schedule.selectedItem,
		rewindMaxHours: state.schedule.rewindMaxHours,
		allowFutureFastForward: state.schedule.allowFutureFastForward,
		accountDropdownIsOpen: state.site.accountDropdownIsOpen
	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {
		getFullScheduleData( day, month, daysOffset, daysOffsetDirection ) {
			dispatch( getFullScheduleData( day, month, daysOffset, daysOffsetDirection ) )
		},

		toggleAccountDropdown() {
			dispatch( toggleAccountDropdown() )
		},

		goToTrack( key ) {
			dispatch( goToTrack( key ) )
		}
	}
}

export default connect( mapStateToProps, mapDispatchToProps )( SchedulePlayer )
